jQuery(document).ready(function ($) {
    const block       = $('.wp-block-jormi-blocks-subnavigation').first();
    if (!block.length) return;

    const variant     = block.data('variant') || 'anchors';
    const activeColor = block.data('active-color');
    const defaultColor = block.data('default-color');

    // ── Shared: sticky behaviour ──────────────────────────────────────────────
    const blockPlaceholder = $('<div>');
    block.before(blockPlaceholder);

    const blockOffset = block.offset().top;
    let lastScroll    = 0;
    let ticking       = false;

    const getOffsets = () => {
        const blockHeight   = block.outerHeight();
        const headerHeight  = $('.site-header').height() || parseFloat($(':root').css('--header-height')) || 0;
        const adminBar      = $('#wpadminbar');
        const adminBarHeight = adminBar.length ? adminBar.outerHeight() : 0;
        return { blockHeight, headerHeight, adminBarHeight };
    };

    const handleSticky = (currentScroll) => {
        // Pages and kit-switcher variants are not sticky.
        if (variant === 'pages' || variant === 'kit-switcher') return;

        const { blockHeight, headerHeight, adminBarHeight } = getOffsets();

        if (currentScroll >= blockOffset) {
            block.css({
                position: 'fixed',
                left: '0',
                right: '0',
                zIndex: '50',
                transition: 'top 0.3s ease',
                top: currentScroll > lastScroll
                    ? `${adminBarHeight}px`
                    : `${headerHeight + adminBarHeight}px`,
            });
            blockPlaceholder.css('height', `${blockHeight}px`);
        } else {
            block.css({ position: 'static' });
            blockPlaceholder.css('height', '0px');
        }
    };

    // ── Anchors variant: scroll-position active state ─────────────────────────
    const navItems = block.find('[data-anchor]').toArray();
    const sections = navItems.map(item => $($(item).attr('data-anchor'))[0]);

    const handleAnchorActive = (currentScroll) => {
        if (!navItems.length) return;

        const { blockHeight, headerHeight, adminBarHeight } = getOffsets();
        const totalOffset   = headerHeight + adminBarHeight + blockHeight;
        const viewportHeight = $(window).height();

        const activeIndex = sections.findIndex(section => {
            if (!section) return false;
            const $section       = $(section);
            const sectionHeight  = $section.outerHeight();
            const sectionTop     = $section.offset().top - totalOffset;
            const sectionBottom  = sectionTop + sectionHeight;
            return currentScroll + viewportHeight > sectionTop + (sectionHeight * 0.10)
                && currentScroll < sectionBottom - (sectionHeight * 0.10);
        });

        navItems.forEach((item, index) => {
            $(item).css({ color: index === activeIndex ? activeColor : defaultColor });
        });
    };

    // ── Unified scroll handler ─────────────────────────────────────────────────
    const handleNavigation = () => {
        const currentScroll = $(window).scrollTop();
        handleSticky(currentScroll);
        if (variant === 'anchors') {
            handleAnchorActive(currentScroll);
        }
        lastScroll = currentScroll;
        ticking    = false;
    };

    $(window).on('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(() => handleNavigation());
            ticking = true;
        }
    });

    handleNavigation(); // initial call

    // Scroll active item into view on load (mobile)
    requestAnimationFrame(function () {
        const inner      = block.find('.wp-block-jormi-blocks-subnavigation__inner')[0];
        const activeLink = inner && inner.querySelector('.wp-block-jormi-blocks-subnavigation__link.is-active');
        if (activeLink && inner) {
            const innerRect = inner.getBoundingClientRect();
            const linkRect  = activeLink.getBoundingClientRect();
            inner.scrollLeft = linkRect.left - innerRect.left;
        }
    });

    // ── Kit-switcher variant ──────────────────────────────────────────────────
    if ( variant === 'kit-switcher' ) {

        function setKitActive( kitType ) {
            block.find( '.wp-block-jormi-blocks-subnavigation__link' ).each( function () {
                const $link = $( this );
                const kit   = $link.data( 'kit' );
                const isActive = kit && kit.toLowerCase() === kitType.toLowerCase();
                $link
                    .toggleClass( 'is-active', isActive )
                    .css( 'color', isActive ? activeColor : defaultColor )
                    .attr( 'aria-current', isActive ? 'page' : 'false' );
            } );
        }

        block.find( '[data-kit]' ).on( 'click', function ( e ) {
            e.preventDefault();

            const kitType = $( this ).data( 'kit' );
            const href    = $( this ).attr( 'href' );

            history.pushState( {}, '', href );
            setKitActive( kitType );

            // kitVariantSwitch triggers setVariation() in functions.php,
            // which handles price, affirm, badge, and gallery in one pass.
            document.dispatchEvent(
                new CustomEvent( 'kitVariantSwitch', { detail: { kitType } } )
            );
        } );

        // Sync initial state from URL (JS overrides the PHP-rendered active state
        // so refreshing mid-session stays consistent).
        const initialKit = new URLSearchParams( window.location.search ).get( 'variant' );
        if ( initialKit ) setKitActive( initialKit );
    }
});